import { FieldProps, InputProps, useField } from 'informed';
import { InputWrapper, InputWrapperProps } from 'ui-forms/src/common';
import { useEffect } from 'react';
import { ActionIcon, FavouriteIcon } from '@tymbe/ui-icons';

interface CustomRangeProps extends InputProps, InputWrapperProps {
}

const CustomRange = (props: FieldProps<CustomRangeProps, string | number, object>) => {
  const { render, userProps, ref, fieldState, fieldApi } = useField(props);
  const { setValue, setTouched, setFocused } = fieldApi;
  const { maskedValue, showError, error, value } = fieldState;
  const { label, id, className, simple, icon, suffix, description, hidden, min = 0, max = 100, onChange, disabled, ...rest } = userProps;

  useEffect(() => {
    if (value < min) {
      setValue(min)
      setTouched(true);
    }
    if (value > max) {
      setValue(max);
      setTouched(true);
    }

  }, [max, min, setTouched, setValue, value]);

  const stepUp = () => {
    setValue(Math.max(Number(min), Math.min(Number(max), Number(maskedValue||0) + 1)));
  }
  const stepDown = () => {
    setValue(Math.max(Number(min), Math.min(Number(max), Number(maskedValue||0) - 1)));
  }

  return render(
    <InputWrapper
      className={className}
      simple={simple}
      error={showError ? String(error) : undefined}
      description={description}
      hidden={hidden}
    >
      <div className="w-full">
        <div className="flex">
          <div className="grow text-body-2-md">{label}</div>
          {icon}
        </div>
        <div className="flex flex-1 my-1 mb-2 border rounded-lg border-secondary-400">
          <input
            ref={ref}
            id={id}
            {...rest}
            disabled={disabled}
            type="text"
            className="text-center peer order-2"
            value={!maskedValue && (maskedValue !== 0 || ref.current?.value === '') ? '0' : maskedValue}
            onChange={(e) => {
              if (e.target.value === '') {
                setValue(0);
              } else if (!Number.isNaN(Number(e.target.value))) {
                setValue(Math.max(Number(min), Math.min(Number(max), Number(e.target.value))));
              }
            }}
            onBlur={(e) => {
              if (!e.target.value) {
                e.target.value = String(maskedValue);
              }
              setTouched(true);
            }}
            onFocus={() => {
              setFocused(true);
            }}
          />
          <button type="button" disabled={disabled} className="m-1 p-1.5 order-1 bg-secondary-50 text-secondary-400 peer-disabled:text-secondary-300 size-8 rounded-md text-center align-middle" onClick={stepDown}><ActionIcon name="minimize" className="size-5" /></button>
          <button type="button" disabled={disabled} className="m-1 p-1.5 order-3 bg-secondary-50 text-secondary-400 peer-disabled:text-secondary-300 size-8 rounded-md text-center align-middle" onClick={stepUp}><FavouriteIcon name="add" className="size-5" /></button>
        </div>
        {suffix}
      </div>
    </InputWrapper>
  );

  /*
  // range input, onchange is not working after useEffect
  return render(
    <InputWrapper
      className={className}
      simple={simple}
      error={showError ? String(error) : undefined}
      description={description}
      hidden={hidden}
    >
      <div className="w-full">
        <div className="flex">
          <div className="grow">{label}</div>
          {icon}
        </div>
        <input
          ref={ref}
          id={id}
          className={classNames(
            'relative bg-red-700 mt-9',
            'after:content-[attr(value)] after:h-6 after:min-w-6 after:absolute after:-top-8 after:-ml-1 after:text-center after:bg-secondary-600 after:text-white after:rounded after:leading-6',
            'after:left-[calc((min(attr(value_type(<number>)),attr(max_type(<number>)))/(attr(max_type(<number>))-attr(min_type(<number>)))*100%)-(min(attr(value_type(<number>)),attr(max_type(<number>)))/(attr(max_type(<number>))-attr(min_type(<number>)))*16px))]',
            'before:absolute before:size-0 before:-top-2 before:ml-1 before:border-l-4 before:border-r-4 before:border-t-[5px] before:border-l-transparent before:border-r-transparent before:border-t-secondary-600',
            'before:left-[calc((min(attr(value_type(<number>)),attr(max_type(<number>)))/(attr(max_type(<number>))-attr(min_type(<number>)))*100%)-(min(attr(value_type(<number>)),attr(max_type(<number>)))/(attr(max_type(<number>))-attr(min_type(<number>)))*16px))]',
            { 'before:!left-0': Number(max) - Number(min) <= 0 },
            { 'after:!left-0': Number(max) - Number(min) <= 0 },
          )}
          {...rest}
          type="range"
          min={min}
          max={max}

          value={!maskedValue && maskedValue !== 0 ? 0 : maskedValue}
          onChange={(e) => {
            setValue(e.target.value, e);
            onChange?.(e);
          }}
          onBlur={(e) => {
            setTouched(true, e);
            setFocused(false, e);
          }}
          onFocus={(e) => {
            setFocused(true, e);
          }}
        />
        {suffix}
      </div>
    </InputWrapper>
  )
  */
}

export default CustomRange;
